import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { VulnerabilityExampleEdit } from '../VulnerabilityExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/vulnerability-example/edit/$id')({
    staticData: {
        breadcrumb: { title: 'Edit' },
        ui: { title: 'Edit vulnerability example' },
        presentation: 'overlay',
    },
    component: EditVulnerabilityExample,
});

function EditVulnerabilityExample() {
    const { id } = Route.useParams();
    return (
        <PageController route={Route}>
            <VulnerabilityExampleEdit mode="edit" id={id} />
        </PageController>
    );
}
